// Utils

import { cloneDeep } from '@utils/miscellaneous/objectHelpers';
import { updateImiValues, updateSsnValues } from '@utils/householdMember/updateMaskedValues';

// Constants

import { dataActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    mockData: true,
    taxHousehold: {
        bloodRelationship: [],
        householdMember: []
    }
};


export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case dataActionTypes.SET_SESSION_INITIAL_DATA:
            return cloneDeep(action.data);
        case dataActionTypes.UPDATE_SSNS:
            if(action.isFromCache) return state;
            return updateSsnValues(state, action.ssns);
        case dataActionTypes.UPDATE_IMI:
            if(action.isFromCache) return state;
            return updateImiValues(state, action.imi);
        case dataActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};